<template>
    <BreadCrumb PageTitle="Ajout des chefs quartiers" />
    <Addchefquartier/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Addchefquartier from "@/components/Assignations/Addchefquartier.vue";
  
    export default defineComponent({
      name: "AddAssignPage",
      components: {
        BreadCrumb,
        Addchefquartier,
      },
    });
  </script>